/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2020-07-01 10:06:38
 * @LastEditors: voanit
 * @LastEditTime: 2020-12-25 10:50:47
 */
import axios from 'axios'
import Qs from 'qs'
import { setMyToken, getMyToken, getUnify } from '@/utils/auth'
export default function download(options) {
  const iframe = document.createElement('iframe')

  const src = 'static-html/download.html'
  iframe.src = src
  iframe.width = 0
  iframe.height = 0
  var d = document.createElement('a')
  console.log(iframe)
  //iframe.created.children("d");
  // iframe.appendChild("d");
  let unify = JSON.parse(getUnify())
  options.token = unify.authorization
  document.body.appendChild(iframe)
  window.loadInfo = options
}
